import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6f92b8f4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-card-cover"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "course-card-info"
};
const _hoisted_4 = {
  class: "top"
};
const _hoisted_5 = {
  class: "course-name text-overflow"
};
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "teacher"
};
const _hoisted_8 = {
  class: "name w text-overflow"
};
const _hoisted_9 = {
  class: "name w-10 ml text-overflow"
};
const _hoisted_10 = {
  class: "time"
};
import { formatDate } from '@/plugins/utils';
import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    info: {
      type: Object
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number,
    showResultTag: Boolean,
    resultMap: Object
  },

  setup(__props) {
    const props = __props;

    const goDetail = () => {
      if (unref(props.authType) == 2 && !unref(props.userInfo)) {
        handleLogin();
      } else {
        props.info.course_url && window.open(unref(props.info.course_url));
      }
    };

    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      return _openBlock(), _createElementBlock("div", {
        onClick: goDetail,
        class: "course-card"
      }, [__props.showResultTag && __props.info.results_id && __props.info.results_name ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "tag-btn",
        style: _normalizeStyle({
          background: __props.resultMap[__props.info.results_id]
        })
      }, _toDisplayString(__props.info.results_name), 5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: __props.info.course_cover_url || require('@/assets/images/common/course_cover.png')
      }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tooltip, {
        content: __props.info.course_name,
        placement: "top-start",
        effect: "light"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.info.course_name), 1)]),
        _: 1
      }, 8, ["content"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.info.lecturer), 1), _createVNode(_component_el_tooltip, {
        content: __props.info.organ_name,
        placement: "top-start",
        effect: "light"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(__props.info.organ_name), 1)]),
        _: 1
      }, 8, ["content"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(__props.info.students_num) + "人参加", 1)])])])]);
    };
  }

};